var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cart-view-b2c',{attrs:{"hasCampaignVoucherEnabled":_vm.checkoutmodel.hasCampaignVoucherEnabled}}),(_vm.cart.orderRows && _vm.cart.orderRows.length > 0)?_c('div',{attrs:{"id":"checkout-widget"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }